import axios from "axios";
import { useState } from "react";

const useAPICall = (defaultData, defaultError) => {
  //handling States
  //this must be set to false
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(defaultData);
  const [error, setError] = useState(defaultError);

  const callAPI = ({
    url = "",
    method = "get",
    defaultFallback = () => {},
    statusObj = [],
    body,
    params,
    config = {},
  }) => {
    // merging all the configurations
    const axiosConfigObject = {
      ...config,
      method,
      url,
      data: body,
      header: {
        ...(config.headers || {}),
      },
      params,
    };
    //setting loading to true pre-call
    setIsLoading(true);
    //axios call
    axios(axiosConfigObject)
      .then((res) => {
        if (res?.data?.status_code && res?.data?.status_txt) {
          //finding the matching status
          let statusID = statusObj.findIndex((status) => {
            return (
              res.data.status_code === status?.status_code &&
              (res.data.status_txt || "").toLowerCase() ===
                status?.status_txt.toLowerCase()
            );
          });

          // if status found
          if (statusID >= 0) {
            // running the callback
            if (statusObj[statusID]?.callBack) {
              statusObj[statusID].callBack(res.data);
            } else {
              console.log("callback is not found for the status");
            }
          } else {
            console.log("status not found");
            defaultFallback();
          }
        }
        // wrong structure
        else {
          console.log("Improper Structure");
          defaultFallback();
        }
      })
      .catch((err) => {
        //handling error from API
        console.log("API error", { err });
        defaultFallback();
      })
      .finally(() => {
        //turning the loader off
        setIsLoading(false);
      });
  };
  return [data, error, isLoading, callAPI, setData, setError, setIsLoading];
};

export default useAPICall;
